export default __webpack_public_path__ + "static/media/6 (2).e119eed0.jpg";